export const envName: keyof typeof envSet = process.env.VUE_APP_DATASET as any

abstract class EnvSet {
    abstract filters: Array<{ short: string, value: string, type?: string }>
    abstract releases: ReleaseList

    dataUrl = '../data'
    abstract databaseService: boolean
    mustLogin = true
}

interface IReleaseOptions {
    reruns: string[],
    cutoutUrl?: string
    cas?: boolean
}

export class Release {
    readonly reruns: string[]
    readonly cutoutUrl?: string
    readonly cas: boolean

    constructor(readonly name: string, options: IReleaseOptions) {
        this.reruns = options.reruns
        this.cutoutUrl = options.cutoutUrl
        this.cas = !!options.cas
    }

    get defaultRerun() {
        return this.reruns[0]
    }

    get defaultFilter() {
        return 'HSC-I'
    }

    static list(rs: Release[]) {
        const list = new ReleaseList()
        list.push(...rs)
        return list
    }
}

class ReleaseList extends Array<Release> {
    get default() {
        return this[0]
    }

    get cas() {
        return this.filter((r) => r.cas)
    }

    get cutout() {
        return this.filter((r) => r.cutoutUrl)
    }
}

const envSet = {

    'hscmap-pdr2': class extends EnvSet {
        filters = [
            { short: 'g', value: 'HSC-G' },
            { short: 'r', value: 'HSC-R' },
            { short: 'i', value: 'HSC-I' },
            { short: 'z', value: 'HSC-Z' },
            { short: 'y', value: 'HSC-Y' },
            // { short: '816', value: 'NB0816', type: 'narrow' },
            // { short: '921', value: 'NB0921', type: 'narrow' },
        ]
        releases = Release.list([
            new Release('pdr2', {
                reruns: ['pdr2_wide', 'pdr2_dud'],
            }),
            // new Release('pdr1', {
            //     reruns: ['pdr1_wide', 'pdr1_deep', 'pdr1_udeep'],
            // }),
        ])
        databaseService = false
        mustLogin = false
        dataUrl = `${location.protocol}//hscmap.mtk.nao.ac.jp/galaxy-cruise-data/pdr2`
    },
}

export const env = new envSet[envName]()
if (env === undefined) {
    alert(`invalid envName = ${process.env.VUE_APP_DATASET}`)
}
